import { IQueryProductsV2WithLeanTileResponse } from "@faire/web-api--source/indigofair/data/IQueryProductsV2WithLeanTileResponse";
import { Row } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { Typography, TypographyVariants } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const getGroupIndexFromEnum = (
  value: keyof typeof IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification
) => {
  switch (value) {
    case IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification
      .LOW:
      return 3;
    case IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification
      .MEDIUM:
      return 1;
    case IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification
      .HIGH:
      return 0;
    case IQueryProductsV2WithLeanTileResponse.OrganicRelevanceClassification
      .ORGANIC_RELEVANCE_CLASSIFICATION_UNKNOWN:
    default:
      return undefined;
  }
};

export const FullSentenceResultCountSubHeader: React.FC<{
  typographyVariant: ResponsiveProp<TypographyVariants>;
  loading: boolean;
  totalPrimaryResultsFormatted: string;
  totalPrimaryResultsCount: number;
  searchStringFullyTranslated: string;
}> = ({
  typographyVariant,
  loading,
  totalPrimaryResultsFormatted,
  totalPrimaryResultsCount,
  searchStringFullyTranslated,
}) => {
  return (
    <Row>
      {loading ? (
        <>
          <LoadingSkeleton width="64px" height="32px" />
          <Spacer width="1x" />
        </>
      ) : null}
      <HeaderTypography variant={typographyVariant}>
        <StrictLocalMsg
          id="gxU/44"
          defaultMessage="{totalCountNumber, plural, one {{formattedTotalNumberFullyTranslatedSentence} result for {searchStringFullyTranslatedSentence}} other {{formattedTotalNumberFullyTranslatedSentence} results for {searchStringFullyTranslatedSentence}}}"
          description={{
            text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
          }}
          values={{
            formattedTotalNumberFullyTranslatedSentence:
              totalPrimaryResultsFormatted,
            totalCountNumber: totalPrimaryResultsCount,
            searchStringFullyTranslatedSentence: searchStringFullyTranslated,
          }}
        />
      </HeaderTypography>
    </Row>
  );
};

const HeaderTypography = styled(Typography)`
  &&& {
    ${responsiveMediaQueries.tabletAndAbove} {
      margin: 0;
    }
  }
`;
